import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ImodOperationsRealtimeModule } from './imodoperationsrealtime.module';

enableProdMode();

platformBrowserDynamic()
  .bootstrapModule(ImodOperationsRealtimeModule, {
    ngZone: (window as any).ngZone
  })
  .catch(err => console.error(err));
